// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Iiim","type":"styles_type__1ubE-","choices":"styles_choices__e6sbf"};